export default __webpack_public_path__ + "static/media/logo-circle.372a7541.png";